import { matchPath } from "react-router-dom";

import { Routes as AppRoutes } from "@/constants/routes";
import { Genders } from "@/types/gender";
import { isNyscDomain } from "@/utils/isNyscFlow";

const newBothContentRoutes = [
    AppRoutes.AgeLift,
    AppRoutes.AgeWeightLoss,
    AppRoutes.AgeWorkout,
    AppRoutes.AgeWorkoutLoader,
    AppRoutes.CreoTests,
    AppRoutes.AgeWorkoutWithoutAI,
    AppRoutes.BothWorkout,
    AppRoutes.BodyScanPlans,
    AppRoutes.WeightLoss,
];

const extractBaseBothPath = (pathname: string) => pathname.split("/").slice(1, 3).join("/");

const enum FunnelTypes {
    both = "both",
    friends = "friends",
    offer = "offer",
    calisthenics = "calisthenics",
    calisthenicsAge = "calisthenics-age",
    pilates = "pilates",
    mex = "mex",
    seniors = "seniors",
    funnelFox = "funnel-fox",
    highIntent = "high-intent",
    creoTests = "creo-tests",
    bodyScan = "body-scan",
    bodyScanAbs = "body-scan-abs",
    bodyScanPlans = "body-scan-plans",
    freeTrial = "free-trial",
    promoCode = "promo-code",
    glp1 = "glp1",
    nysc = "nysc",
}

type AllFunnelTypes = FunnelTypes | Genders;

export const getFunnelTypeForAnalytics = (gender: Genders): AllFunnelTypes | string => {
    const isBoth = matchPath(
        {
            path: `/${AppRoutes.Both}`,
            end: false,
        },
        window.location.pathname
    );
    const isBothGoogle = matchPath(
        {
            path: `/${AppRoutes.BothGoogle}`,
            end: false,
        },
        window.location.pathname
    );
    const isDynamicBothGoogle = matchPath(
        {
            path: `/${AppRoutes.DynamicBoth}`,
            end: false,
        },
        window.location.pathname
    );
    const isGLP1 = matchPath(
        {
            path: `/${AppRoutes.GLP1}`,
            end: false,
        },
        window.location.pathname
    );
    const isFriends = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.Friends}`,
            end: false,
        },
        window.location.pathname
    );
    const isOfferUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.Offer}`,
            end: false,
        },
        window.location.pathname
    );
    const isSeniorsUrl = matchPath(
        {
            path: `/${AppRoutes.Seniors}`,
            end: false,
        },
        window.location.pathname
    );
    const isSeniorsApplovinUrl = matchPath(
        {
            path: `/${AppRoutes.SeniorsApplovin}`,
            end: false,
        },
        window.location.pathname
    );
    const isCalisthenicsUrl = matchPath(
        {
            path: `/${AppRoutes.Calisthenics}`,
            end: false,
        },
        window.location.pathname
    );

    const isCalisthenicsAgeUrl = matchPath(
        {
            path: `/${AppRoutes.CalisthenicsAge}`,
            end: false,
        },
        window.location.pathname
    );

    const isBothCalisthenicsUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.Calisthenics}`,
            end: false,
        },
        window.location.pathname
    );

    const isBothCalisthenicsAgeUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.CalisthenicsAge}`,
            end: false,
        },
        window.location.pathname
    );
    const isMexUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.Mex}`,
            end: false,
        },
        window.location.pathname
    );
    const isFreeTrialUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.FreeTrial}`,
            end: false,
        },
        window.location.pathname
    );

    const isAgeWorkoutUrl = matchPath(
        {
            path: `/${AppRoutes.AgeWorkout}`,
            end: false,
        },
        window.location.pathname
    );

    const isBothCreoTestsUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.CreoTests}`,
            end: false,
        },
        window.location.pathname
    );

    const isCreoTestsUrl = matchPath(
        {
            path: `/${AppRoutes.CreoTests}`,
            end: false,
        },
        window.location.pathname
    );

    const isHighIntentUrl = matchPath(
        {
            path: `/${AppRoutes.Both}/${AppRoutes.HighIntent}`,
            end: false,
        },
        window.location.pathname
    );

    const isPilatesUrl = matchPath(
        {
            path: `/${AppRoutes.Pilates}`,
            end: false,
        },
        window.location.pathname
    );

    const isBodyScanUrl = matchPath(
        {
            path: `/${AppRoutes.BodyScan}`,
            end: false,
        },
        window.location.pathname
    );
    const isBodyScanAbsUrl = matchPath(
        {
            path: `/${AppRoutes.BodyScanAbs}`,
            end: false,
        },
        window.location.pathname
    );

    const isBodyScanPlansUrl = matchPath(
        {
            path: `/${AppRoutes.BodyScanPlans}`,
            end: false,
        },
        window.location.pathname
    );
    const isBodyScanPlansApplovinUrl = Boolean(
        matchPath(
            {
                path: `/${AppRoutes.Both}/${AppRoutes.BodyScanPlansApplovin}`,
                end: false,
            },
            window.location.pathname
        ) ||
            matchPath(
                {
                    path: `/${AppRoutes.BodyScanPlansApplovin}`,
                    end: false,
                },
                window.location.pathname
            )
    );

    const isFunnelFoxUrl = matchPath(
        {
            path: `/${AppRoutes.FFPaywall}`,
            end: false,
        },
        window.location.pathname
    );

    const isPromoCodeUrl = matchPath(
        {
            path: `/${AppRoutes.RedeemCode}`,
            end: false,
        },
        window.location.pathname
    );

    const isNyscUrl =
        matchPath(
            {
                path: `/${AppRoutes.Nysc}`,
                end: false,
            },
            window.location.pathname
        ) || isNyscDomain();

    const newBothType =
        isBoth &&
        newBothContentRoutes.find((route) => window.location.pathname.split("/").includes(route));

    if (isCalisthenicsUrl) {
        return FunnelTypes.calisthenics;
    } else if (isCalisthenicsAgeUrl) {
        return FunnelTypes.calisthenicsAge;
    } else if (isDynamicBothGoogle) {
        return extractBaseBothPath(window.location.pathname);
    } else if (isBoth || isBothGoogle) {
        if (isFriends) return FunnelTypes.friends;
        if (isOfferUrl) return FunnelTypes.offer;
        if (newBothType) return `${FunnelTypes.both}/${newBothType}`;
        if (isBothCalisthenicsUrl) return `${FunnelTypes.both}/${FunnelTypes.calisthenics}`;
        if (isBothCalisthenicsAgeUrl) return `${FunnelTypes.both}/${FunnelTypes.calisthenicsAge}`;
        if (isMexUrl) return `${FunnelTypes.both}/${FunnelTypes.mex}`;
        if (isFreeTrialUrl) return `${FunnelTypes.both}/${FunnelTypes.freeTrial}`;
        if (isHighIntentUrl) return `${FunnelTypes.both}/${FunnelTypes.highIntent}`;
        if (isBothCreoTestsUrl) return `${FunnelTypes.both}/${FunnelTypes.creoTests}`;
        if (isBodyScanPlansApplovinUrl) return `${FunnelTypes.both}/${FunnelTypes.bodyScanPlans}`;
        return FunnelTypes.both;
    } else if (isGLP1) {
        return FunnelTypes.glp1;
    } else if (isAgeWorkoutUrl) {
        return AppRoutes.AgeWorkout;
    } else if (isCreoTestsUrl) {
        return FunnelTypes.creoTests;
    } else if (isPilatesUrl) {
        return FunnelTypes.pilates;
    } else if (isFunnelFoxUrl) {
        return FunnelTypes.funnelFox;
    } else if (isBodyScanUrl) {
        return FunnelTypes.bodyScan;
    } else if (isBodyScanAbsUrl) {
        return FunnelTypes.bodyScanAbs;
    } else if (isBodyScanPlansUrl || isBodyScanPlansApplovinUrl) {
        return FunnelTypes.bodyScanPlans;
    } else if (isSeniorsUrl || isSeniorsApplovinUrl) {
        return FunnelTypes.seniors;
    } else if (isPromoCodeUrl) {
        return FunnelTypes.promoCode;
    } else if (isNyscUrl) {
        return FunnelTypes.nysc;
    }

    return gender;
};
